document.addEventListener('DOMContentLoaded', function () {
  // --- Табы на странице прайс-листа ---
  const priceContainers = document.querySelectorAll('.price-list-container');

  priceContainers.forEach(function (container) {
    const tabBarElement = container.querySelector('.mdc-tab-bar');
    if (tabBarElement) {
      const tabBar = mdc.tabBar.MDCTabBar.attachTo(tabBarElement);
      const contentEls = container.querySelectorAll('.tab-content');

      tabBar.listen('MDCTabBar:activated', function (event) {
        // Скрываем все панели внутри этого контейнера
        contentEls.forEach(function (el) {
          el.classList.remove('tab-content--active');
        });

        // Показываем нужную панель
        contentEls[event.detail.index].classList.add('tab-content--active');
      });
    }
  });
});